import { useEffect, useState } from "react";

/**
 * Subscribes to a media query.
 *
 * `<picture>` handles the desktop/mobile swap for images declaratively, but `<video>`
 * ignores the `media` attribute on its `<source>` children, so video slides need the
 * breakpoint resolved in JS.
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);

    setMatches(mql.matches);

    // Safari < 14 only has the deprecated addListener/removeListener pair.
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
